export const EmptyPoolExclChargeTypePolicy = ({
    CHARGE_TYPE_EMP: "EMP",
    CHARGE_TYPE_FLP: "FLP",
})